import { useEffect, useRef } from 'react';
import { youtubeVideoId } from '../../utils/youtube';

interface EventRecordingProps {
  url: string;
  title: string;
  autoplay?: boolean;
}

export default function EventRecording({ url, title, autoplay = false }: EventRecordingProps) {
  const videoId = youtubeVideoId(url);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!autoplay || !videoId) return;
    containerRef.current?.scrollIntoView({ block: 'start' });
  }, [autoplay, videoId]);

  if (!videoId) return null;

  const src = autoplay
    ? `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1`
    : `https://www.youtube-nocookie.com/embed/${videoId}`;

  return (
    <div ref={containerRef} id="recording" className="mb-8 scroll-mt-28">
      <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
        <iframe
          src={src}
          className="absolute top-0 left-0 w-full h-full rounded-lg"
          title={`Recording: ${title}`}
          allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
